(function($){





$(document).ready(function (e){
    if ( $(window).width() <= 767 ){
        mobile_fit_tables();
    }
});

$(window).resize(function(e){
    if ( $(window).width() <= 767 ){
        mobile_fit_tables();
    }
});

function mobile_fit_tables(){
    if ( $('.wptb-table-container-matrix').length ){

        $('.wptb-table-container-matrix').each(function(i,e){
            $(e).find('tr').each(function (i,e){
                var $basic_width = $(e).find('td').first().outerWidth();
                $(e).find('td').each(function(i,e){
                    if ( $(e).attr('colspan') != undefined ){
                        var value = $(e).attr('colspan');
                        //$(e).width( $basic_width * value );
                        $(e).css({
                            'width' : $basic_width * value,
                            'minWidth' : $basic_width * value,
                        })

                    }
                });
            })
        });
    }
}



$(document).ready(function () {
    if($('.overflow-filter').length){
        // Drag post tag */
        var sliders = [].slice.call(document.querySelectorAll(".overflow-filter"));
        sliders.forEach(function(slider) {
            var isDown = false;
            var startX;
            var scrollLeft;

            slider.addEventListener('mousedown', function(e){
                isDown = true;
                slider.classList.add('active');
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener('mouseleave', function() {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mouseup', function() {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mousemove', function(e) {
                if(!isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * 3; //scroll-fast
                slider.scrollLeft = scrollLeft - walk;
            });

        });
    }

});

$('.overflow-filter').each(function(){
    $(this).scroll( function() {
        var $width = $(this).outerWidth()
        var $scrollWidth = $(this)[0].scrollWidth;
        var $scrollLeft = $(this).scrollLeft();

        $(this).parents('.tag-filter').addClass('scrolling');
        $(this).parents('.tag-filter').removeClass('scroll-end');

        if ($scrollWidth - $width === $scrollLeft){
            $(this).parents('.tag-filter').removeClass('scrolling');
            $(this).parents('.tag-filter').addClass('scroll-end');
        }
        if ($scrollLeft===0){
            $(this).parents('.tag-filter').removeClass('scrolling');
            $(this).parents('.tag-filter').removeClass('scroll-end');
        }
    });
});


/* mosaic height ajust */
$(document).ready(function () {
    if($('.mosaic').length){
        $('.mosaic').each(function(){
            $(this).find('.et_pb_video_box').each(function(){
                $(this).parents('.et_pb_row').addClass('contain-video');
            });
        });
    }
});


    $(document).ready(function () {
        data = {};
        data.action = 'check_geoip_force_session';
        jQuery.post( ajax, data, function ( response ) {
            switch(response.region){
                case 'none':
                    geoip_detect.get_info().then(function (record) {
                        if (record.error()) {
                            $('#country-selector').find('li.selected').removeClass('selected');
                            $('#country-selector').find('li[data-value="WORLD"]').addClass('selected');
                            $('#country-selector').find('.current').text('Region : WORLD');
                            $('#country-selector select').val('WORLD');
                        } else {
                            switch (record.get('country.iso_code')) {
                                case 'US':
                                    $('#country-selector').find('li.selected').removeClass('selected');
                                    $('#country-selector').find('li[data-value="US"]').addClass('selected');
                                    $('#country-selector').find('.current').text('Region : US');
                                    $('#country-selector select').val('US');
                                    window.location.replace("https://us.elinchrom.com");
                                    break;
                                default:
                                    $('#country-selector').find('li.selected').removeClass('selected');
                                    $('#country-selector').find('li[data-value="WORLD"]').addClass('selected');
                                    $('#country-selector').find('.current').text('Region : WORLD');
                                    $('#country-selector select').val('WORLD');
                                    break;
                            }
                        }
                    });
                    break;
                default:
                    $('body').addClass('geoip-force');
                    $('body').addClass('geoip-force-'+response.region);


                    $('#country-selector').find('li.selected').removeClass('selected');
                    $('#country-selector').find('li[data-value="'+response.region+'"]').addClass('selected');
                    $('#country-selector').find('.current').text('Region : '+response.region);
                    $('#country-selector select').val(response.region);

                    if(response.region == "US"){ window.location.replace("https://us.elinchrom.com"); }


                    break;
            }
        } );


        $('#country-selector select').on('change', function (e) {
            var select = $(this);
            geoip_detect.get_info().then(function (record) {
                if (record.error()) {
                    var country = 'WORLD';
                }else{
                    var country = record.get('country.iso_code');
                }
                if($('body').hasClass('geoip-force-US')) country = 'US';
                if($('body').hasClass('geoip-force-WORLD')) country = 'WORLD';
                if(
                    (country == "US" && select.val() == "US") ||
                    (country != "US" && select.val() != "US")){

                    // no change
                }else{
                    $('body').addClass('geoip-force');
                    data = {};
                    data.action = 'geoip_force';
                    switch(select.val()){
                        case 'US' :
                            $('body').addClass('geoip-force-US');
                            $('body').removeClass('geoip-force-WORLD');
                            data.region='US';
                            window.location.replace("https://us.elinchrom.com");
                            break;
                        default:
                            $('body').removeClass('geoip-force-US');
                            $('body').addClass('geoip-force-WORLD');
                            data.region='WORLD';
                            break;
                    }
                    jQuery.post( geoip_detect.options.ajaxurl, data, function ( response ) {    } );

                }
            });
        });


        if($('div.usAnnouncement').length){
            setTimeout(function(){
                $('div.usAnnouncement').animate( {right: "0px"},500 );
            },1000);


        }


    });


var menu = {
    init: function () {
        this.logo_white = true;
        this.logo = $('.custom-logo');
        this.logo_white_src = this.logo.attr('data-logo');
        this.logo_black_src = this.logo.attr('data-hover');

        if ( $('#main-header').length ){
            $(document).ready(this.menu_on_scroll.bind(this));
            $(window).scroll(this.menu_on_scroll.bind(this));
            $(window).resize(this.menu_on_scroll.bind(this));
            window.addEventListener("orientationchange", this.menu_on_scroll.bind(this));
        }
    },
    menu_on_scroll: function () {

        this.topPage = $(window).scrollTop();

        this.menu = $('#main-nav');
        this.menuHeight = this.menu.height();
        this.menuPosition = this.topPage+this.menuHeight;

        this.firstSection = $('#main-header');
        this.firstSectionTop = this.firstSection.offset().top;
        this.firstSectionHeight = this.firstSectionTop + this.firstSection.height();
        this.firstSectionPosition = this.firstSectionTop+this.firstSectionHeight;

        if ( this.menuPosition >= this.firstSectionPosition ){
            this.menu.addClass('colored');
            this.change_logo_to_black();
        } else {
            this.menu.removeClass('colored');
            this.change_logo_to_white();
        }
    },
    change_logo_to_white: function () {
        if ( !this.logo_white ){
            this.logo.attr('src', this.logo_white_src);
            this.logo_white = true;
        }
    },
    change_logo_to_black: function () {
        if ( this.logo_white ){
            this.logo.attr('src', this.logo_black_src);
            this.logo_white = false;
        }
    }
};





function lazy_images(){
    document.addEventListener("DOMContentLoaded", function() {
        var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
        var active = false;

        var lazyLoad = function() {
            if (active === false) {
                active = true;

                setTimeout(function() {
                    lazyImages.forEach(function(lazyImage) {
                        if ((lazyImage.getBoundingClientRect().top <= (window.innerHeight + 200) && lazyImage.getBoundingClientRect().bottom >= -40) && getComputedStyle(lazyImage).display !== "none") {
                            lazyImage.src = lazyImage.dataset.src;
                            lazyImage.classList.remove("lazy");


                            //lazyImage.parentNode.classList.add("visible");

                            // anime when loaded
                            if (lazyImage.complete) {
                                setTimeout(function() {
                                    lazyImage.closest('.reveal-holder').classList.add("animated");
                                }, 50);
                                return;
                            }

                            // anime when loaded
                            lazyImage.addEventListener(
                                'load',
                                function(){
                                    setTimeout(function() {
                                        lazyImage.closest('.reveal-holder').classList.add("animated");
                                    }, 50);
                                },
                                false
                            );


                            lazyImages = lazyImages.filter(function(image) {
                                return image !== lazyImage;
                            });

                            if (lazyImages.length === 0) {
                                document.removeEventListener("scroll", lazyLoad);
                                window.removeEventListener("resize", lazyLoad);
                                window.removeEventListener("orientationchange", lazyLoad);
                            }
                        }
                    });

                    active = false;
                }, 0);
            }
        };

        document.addEventListener("scroll", lazyLoad);
        window.addEventListener("resize", lazyLoad);
        window.addEventListener("orientationchange", lazyLoad);
    });
}
// Create custom select
function create_custom_dropdowns() {

    $('select.order-options').each(function() {
        var options = $(this).find("option[value!='all']"); // Collect options
        options.detach().sort(function(a,b) {// Detach from select, then Sort
            var at = $(a).text();
            var bt = $(b).text();
            return (at > bt)?1:((at < bt)?-1:0);            // Tell the sort function how to order
        });
        options.appendTo($(this));
    });

    $('select[data-for="mce-COUNTRY"]').select2({
        dropdownParent: $('#website-content #the-content'),
        placeholder:  $('select[data-for="mce-COUNTRY"]').attr('data-placeholder')
    }).on("select2:open", function(event) {
        $('input.select2-search__field').attr('placeholder', 'Search...');
    }).on("select2:select", function(e) {
        $('input#mce-COUNTRY').val(e.params.data.text);
    });



    $('select:not([data-for="mce-COUNTRY"])').each(function(i, select) {
        console.log("Change this <select> dropdown for select2 -> ");
        console.log($(select));
        $(this).after('<div class="dropdown ' + ($(this).attr('class') || '') + '" tabindex="0"><span class="current"></span><div class="list"><ul></ul></div></div>');
        var dropdown = $(this).next();
        var options = $(select).find('option');
        var selected = $(this).find('option:selected');
        var originalSelect = $(select);
        dropdown.find('.current').html(selected.data('display-text') || selected.text());
        options.each(function (j, o) {
            var display = $(o).data('display-text') || '';
            var li = $('<li class="option ' + ($(o).is(':selected') ? 'selected' : '') + '" data-value="' + $(o).val() + '" data-display-text="' + display + '">' + $(o).text() + '</li>');
            li.click(function(){

                var attr = originalSelect.attr('data-for');
                if (typeof attr !== typeof undefined && attr !== false) {
                    if(attr != "") {
                        $('input#'+attr).val($(this).text());
                    }
                }
            });
            dropdown.find('ul').append(li);
        });
    });
}

function perfectscroll(){

    if($('.dropdown').length){
        $('.dropdown .list ul').each(function(){
            const dropscroll = new PerfectScrollbar($(this)[0], {
                minScrollbarLength: 40,
                suppressScrollX: false,
                wheelSpeed: 1.2,
                wheelPropagation: true,
                swipeEasing: true,
            });
        });
    }

    if($('.store-infos-content').length){
        const mapscroll = new PerfectScrollbar('#store-infos', {
            minScrollbarLength: 40,
            suppressScrollX: false,
            wheelSpeed: 1.2,
            wheelPropagation: true,
            swipeEasing: true,
        });
    }

    /*if($('#store-countries-listing').length){
        const mapscroll = new PerfectScrollbar('#store-countries-listing', {
            minScrollbarLength: 40,
            suppressScrollX: false,
            wheelSpeed: 1.2,
            wheelPropagation: true,
            swipeEasing: true,
        });
    }*/
    if($('#store-services-listing').length){
        const mapscroll = new PerfectScrollbar('#store-services-listing', {
            minScrollbarLength: 40,
            suppressScrollX: false,
            wheelSpeed: 1.2,
            wheelPropagation: true,
            swipeEasing: true,
        });
    }

    if($('.multi-select-list').length){
        $('.multi-select-list').each(function(){
            const multiSelectScroll = new PerfectScrollbar($(this)[0], {
                minScrollbarLength: 40,
                suppressScrollX: false,
                wheelSpeed: 1.2,
                wheelPropagation: true,
                swipeEasing: true,
            });
        });
    }

    if($('#store-tabs-content-area').length){
        const mapscroll = new PerfectScrollbar('#store-tabs-content-area', {
            minScrollbarLength: 40,
            suppressScrollX: false,
            wheelSpeed: 1.2,
            wheelPropagation: true,
            swipeEasing: true,
        });
    }

    if($('.overflow-filter').length){
        $('.overflow-filter').each(function(){
            const overflowfilter = new PerfectScrollbar($(this)[0], {
                minScrollbarLength: 40,
                suppressScrollX: false,
                wheelSpeed: 1.2,
                wheelPropagation: true,
                swipeEasing: true,
            });
        });
    }
}

function productTabs(){

    var defaultOpenTab = $('.tab-title.active-tab').attr("href");
    $(defaultOpenTab).addClass('open');

    /* Blurbs as Tabs */
    $('.tab-title').each(function () {
        var section_id = $(this).attr("href");
        $(this).attr('data-url', section_id);
        $(this).removeAttr("href");
        $(this).click(function() {
            $(this).siblings().removeClass("active-tab");
            $(this).addClass("active-tab");
            $("[id^='product-tab-'], [id*='product-tab-']").removeClass('open');
            $(section_id).addClass('open');
        });
    });
}

//Menu mobile open
function mobileMenu(){
    $('.menuburger').click(function(){
        if ($(this).hasClass('active')){
            $(this).removeClass('active');
            $('#main-nav').removeClass('menu-opened');
            $('#main-nav .mobile-nav').fadeOut();
            $('#main-nav .mobile-nav .sub-menu').removeClass('sub-opened');
            $('#main-nav .mobile-nav .sub-menu').css('overflow-y', 'auto');
            $('body, html').removeClass('no-scroll');
        }else{
            $(this).addClass('active');
            $('#main-nav').addClass('menu-opened');
            $('#main-nav .mobile-nav').fadeIn();
            $('body, html').addClass('no-scroll');
        }
    });

    $('#secondary-menu > .wpml-ls-item').clone().prependTo(".mobile-nav #mobile-main-menu");
    $('#secondary-menu > .shop-item a').clone().appendTo(".mobile-nav #mobile-main-menu > .wpml-ls-item");
    $('.mobile-nav .search-form').insertAfter(".mobile-nav #mobile-main-menu > .wpml-ls-item");

    $('#mobile-main-menu .sub-menu').each(function(){
        var parentName = $(this).siblings('a:first-of-type').text();
        var parentLink = $(this).siblings('a:first-of-type').attr('href');
        $(this).prepend('<li class="sub-header"><a href="#" class="back-nav"><i class="icon-Arrow rotate-180"></i></a><a href="'+ parentLink  +'" class="parent-page">' + parentName +'</a></li>');
    });

    $(document).on('click', '#mobile-main-menu .menu-item-has-children > a', function(e){
        e.preventDefault();
        var parentHeight = $(this).parents('.sub-menu').outerHeight();
        $(this).siblings('.sub-menu').addClass('sub-opened');
        $('.mobile-nav, .sub-menu').animate({
            scrollTop: 0
        }, 300);
        $(this).parents('.sub-menu').css('overflow-y', 'hidden');
    });

    $('#mobile-main-menu .sub-menu li.sub-header a.back-nav').click(function(e){
        e.preventDefault();
        $(this).parent().parent().removeClass('sub-opened');
        $(this).parent().parent().parents('.sub-menu').css('overflow-y', 'auto');
        $('.mobile-nav, .sub-menu').animate({
            scrollTop: 0
        }, 300);
    });
}

function desktopMenu(){

    $('#main-nav #main-menu .menu-item-img').each(function(){
        $(this).parent().siblings('.sub-menu').appendTo($(this).siblings('.menu-item-text'));
    });

    $("#main-nav #main-menu > li.menu-item-has-children").hover(function(){
        $('body').addClass('submenu-open');
    }, function(){
        $('body').removeClass('submenu-open');
    });
}

function footerMobile(){

    /*if(window.innerWidth <= 991){
        $('#subfooter-menu li').addClass('subfooter-item');
        $('#subfooter-menu li').appendTo($('#footer-menu'));

    }else{
        $('#footer-menu li.subfooter-item').appendTo($('#subfooter-menu'));
        $('#subfooter-menu li').removeClass('subfooter-item');
    }*/

    if(window.innerWidth <= 576){
        $('.newsletter-form-area form > select, .newsletter-form-area form > .dropdown, .newsletter-form-area form > button').appendTo($('.newsletter-form-area form .flex'));

    }else{
        $('.newsletter-form-area .flex form select, .newsletter-form-area form .flex .dropdown, .newsletter-form-area form .flex button').appendTo($('.newsletter-form-area form'));
    }
}

function searchDesktop(){
    $('#secondary-menu .search-item').click(function(e){
        e.preventDefault();
        $('.search-container').css("display", "flex")
            .hide()
            .fadeIn();
        $('body, html').addClass('no-scroll');
        $('.search-container input[type="text"]').focus();
    });

    $('.close-search').click(function(){
        $('.search-container').fadeOut();
        $('body, html').removeClass('no-scroll');
    });
}

function resetForm(){

    $('.filters-reset').click(function(){
        $(this).parents('form').trigger('reset');
        $(this).parents('form').trigger('change');


        $(this).parents('form').find('select').each(function(){
            // Reset Ambassadors & articles
            $(this).trigger('change');
            var val = $(this).val();
            $(this).next('.dropdown').find('.list .selected').removeClass('selected');
            $(this).next('.dropdown').find('.option[data-value="' + val + '"]').addClass('selected');
            var text = $(this).next('.dropdown').find('.option[data-value="' + val + '"]').text();
            $(this).next('.dropdown').find('.current').text(text);
            // Reset Galleries
            $(this).next('.dropdown').find('.option[data-value="' + val + '"]').trigger('click');
        });

        $(this).parents('form').find('input').each(function(){
            $(this).trigger('change');
        });
    });
}

function placeButton(){
    var lastinputbottom = $('.filters-form .show-result-area').prev().offset().top + $('.filters-form .show-result-area').prev().height() + 20;
    var buttontop = $('.filters-form .show-result-area').offset().top;
    if(buttontop <= lastinputbottom){
        $('.filters-form').css({
            'display': 'block',
        });
    }else{
        $('.filters-form').css({
            'display': 'flex',
        });
    }
}

function mosaicVideo(){
    if($('.mosaic').length){
        $('.mosaic .et_pb_video').each(function(){
            $(this).parents('.et_pb_row').css('height', 'auto');
        });
    }
}

function open_filters(){
    // empecher le scroll global

    $('.filters-show').on('click', function (e) {
        e.preventDefault();
        $('html, body').addClass('noscroll');
        $('.filters-form .col-md-3, .form-controls, .filters-form').addClass('active');
        $('body').addClass('filter-opened');
        $('.filters-form .col-md-12, .filters-show-area').addClass('inactive');
        placeButton();
        $(window).resize(function(){
            placeButton();
        });
        if( navigator.userAgent.match(/iPhone/i) ||  navigator.userAgent.match(/iPod/i)){
            $('.filters-form').css('padding-bottom', '80px');
        }
    });

    $('.close-icon-round, .show-result').on('click', function (e) {
        e.preventDefault();
        $('html, body').removeClass('noscroll');
        $('body').removeClass('filter-opened');
        $('.filters-form .col-md-3, .form-controls, .filters-form').removeClass('active');
        $('.filters-form .col-md-12, .filters-show-area').removeClass('inactive');
        if( navigator.userAgent.match(/iPhone/i) ||  navigator.userAgent.match(/iPod/i)){
            $('.filters-form').css('padding-bottom', '0px');
        }
        $('.filters-form').css({
            'display': 'flex',
        });
    });

}






menu.init();

lazy_images();

// Open/close
$(document).on('click', '.dropdown, .dropdown .ps__rail-y', function(event) {
    $('.dropdown').not($(this)).removeClass('open');
    $(this).toggleClass('open');
    if ($(this).hasClass('open')) {
        $(this).find('.option').attr('tabindex', 0);
        $(this).find('.selected').focus();
    } else {
        $(this).find('.option').removeAttr('tabindex');
        $(this).focus();
    }
});
// Close when clicking outside
$(document).on({ 'touchstart' : function(event){
        if ($(event.target).closest('.dropdown').length === 0) {
            $('.dropdown').removeClass('open');
            $('.dropdown .option').removeAttr('tabindex');
        }
        event.stopPropagation();
    }});

$(document).click(function(event) {
    if ($(event.target).closest('.dropdown').length === 0) {
        $('.dropdown').removeClass('open');
        $('.dropdown .option').removeAttr('tabindex');
    }
    event.stopPropagation();
});

// Option click
$(document).on('click', '.dropdown .option', function(event) {
    $(this).closest('.list').find('.selected').removeClass('selected');
    $(this).addClass('selected');
    var text = $(this).data('display-text') || $(this).text();
    $(this).closest('.dropdown').find('.current').text(text);
    $(this).closest('.dropdown').prev('select').val($(this).data('value')).trigger('change');
});

// Keyboard events
$(document).on('keydown', '.dropdown', function(event) {
    var focused_option = $($(this).find('.list .option:focus')[0] || $(this).find('.list .option.selected')[0]);
    // Space or Enter
    if (event.keyCode == 32 || event.keyCode == 13) {
        if ($(this).hasClass('open')) {
            focused_option.trigger('click');
        } else {
            $(this).trigger('click');
        }
        return false;
        // Down
    } else if (event.keyCode == 40) {
        if (!$(this).hasClass('open')) {
            $(this).trigger('click');
        } else {
            focused_option.next().focus();
        }
        return false;
        // Up
    } else if (event.keyCode == 38) {
        if (!$(this).hasClass('open')) {
            $(this).trigger('click');
        } else {
            var focused_option = $($(this).find('.list .option:focus')[0] || $(this).find('.list .option.selected')[0]);
            focused_option.prev().focus();
        }
        return false;
        // Esc
    } else if (event.keyCode == 27) {
        if ($(this).hasClass('open')) {
            $(this).trigger('click');
        }
        return false;
    }
});

// Accordion start
$(document).on('click', '.accordion-theme', function (e) {
    var theme = $(e.currentTarget);
    var group = theme.next('.accordion-group');
    if ( !theme.hasClass('active') ){
        group.slideDown();
        theme.addClass('active')
        return;
    }

    group.slideUp();
    theme.removeClass('active');
});
$(document).on('click','.accordion-item .accordion-title', function(){
    if ($(this).hasClass('open')){
        $(this).removeClass('open');
        $(this).parents('.accordion-item').find('.accordion-content').slideUp();
        $(this).parents('.accordion-item').removeClass('active');

    }else{
        $(this).parents('.accordion-group').find('.accordion-item .accordion-title').removeClass('open');
        $(this).addClass('open');
        $(this).parents('.accordion-group').find('.accordion-content').slideUp();
        $(this).parents('.accordion-item').find('.accordion-content').slideDown();
        $(this).parents('.accordion-group').find('.accordion-item').removeClass('active');
        $(this).parents('.accordion-item').addClass('active');
        setTimeout(function(){
            var speed = 300;
            var hrefTarget = $(this).parent();
            if($('.product-menu').length){
                var submenuHeight = $('.product-menu').outerHeight();
                var top = submenuHeight + 20;
            }else if($('.anchor-menu').length){
                var submenuHeight = $('.anchor-menu').outerHeight();
                var top = submenuHeight + 20;
            }else{
                var top = 20;
            }
            $('html, body').animate({
                scrollTop: (($(hrefTarget).offset().top) - top)
            }, speed);
        }.bind(this), 350);
    }
});
// Accordion end

// Mosaic transform img into bg
/*$('.mosaic').each(function(){
    $(this).find('img').each(function(){
        var url1 = $(this).attr('src');
        //$(this).css('display','none')
        $(this).parents('.et_pb_image_wrap').css('background-image', 'url(' + url + ')');
    });
});*/

$(window).resize(function(){
    footerMobile();
});

$( document ).ready(function() {
    create_custom_dropdowns();
    productTabs();
    mobileMenu();
    perfectscroll();
    desktopMenu();
    footerMobile();
    searchDesktop();
    resetForm();
    mosaicVideo();
});

/* filters mobile open */
open_filters();









$(window).on('load', function(){
    $('.feature-line').each(function(){
        $(this).find('.img-area').fadeIn();
    });
});


})(jQuery);